export const checkProfileCompleteness = (user) => {
  const steps = [
    { field: "first_name", path: "/basicdetails" },
    { field: "Birthday", path: "/basicdetails" },
    { field: "email_verified_at", path: "/emailverify" },
    { field: "Gender", path: "/abtyourself" },
    { field: "PreferredGender", path: "/abtyourself" },
    { field: "medias", path: "/selfie", minLength: 3 },
    { field: "location_id", path: "/located" },
    { field: "religion_id", path: "/religion" },
    { field: "study_id", path: "/edu" },
    { field: "job_id", path: "/jobtitle" },
    { field: "growth_id", path: "/height" },
    { field: "languages", path: "/religion", minLength: 1 },
    { field: "Personalities", path: "/personality", minLength: 3 },
    { field: "question_answers", path: "/profile-answers", minLength: 2 },
  ];

  for (const step of steps) {
     const value = user[step.field];

     // Allow 'null' for Gender/PreferredGender as it signifies "Open to all"
     if ((step.field === "Gender" || step.field === "PreferredGender") && value === null) {
       continue;
     }

     if (
       value === undefined ||
       value === null ||
       (Array.isArray(value) && value.length < (step.minLength || 1))
     ) {
       return { complete: false, missingStep: step };
     }
   }
   return { complete: true };
};

export function handleUserNavigation(result, navigate, setLoading, type) {
  const user = result[0] || result;
  const approval = user.approval;

  const requiredSteps = [
    { field: "first_name", path: "/basicdetails" },
    { field: "Birthday", path: "/basicdetails" },
    { field: "email_verified_at", path: "/emailverify" },
    { field: "Gender", path: "/abtyourself" },
    { field: "PreferredGender", path: "/abtyourself" },
    { field: "medias", path: "/selfie", minLength: 3 },
    { field: "location_id", path: "/located" },
    { field: "religion_id", path: "/religion" },
    { field: "study_id", path: "/edu" },
    { field: "job_id", path: "/jobtitle" },
    { field: "growth_id", path: "/height" },
    { field: "languages", path: "/religion", minLength: 1 },
    { field: "Personalities", path: "/personality", minLength: 3 },
    { field: "question_answers", path: "/profile-answers", minLength: 2 },
  ];

  for (const step of requiredSteps) {
    const value = user[step.field];

    // Allow 'null' for Gender/PreferredGender as it signifies "Open to all"
    if ((step.field === "Gender" || step.field === "PreferredGender") && value === null) {
      continue;
    }

    if (
      value === undefined ||
      value === null ||
      (Array.isArray(value) && value.length < (step.minLength || 1))
    ) {
      navigate(step.path);
      return;
    }
  }

  // If all profile fields are complete, check approval status
  if ([10, 15, 20, 30, 40].includes(approval)) {
    if ((!(user.phone) || !(user.Email)) && type === 'home') {
      navigate("/accoutsetting");
    } else {
      navigate("/user/home");
    }
  } else {
    setLoading(false);
  }
}
